<template>
  <div class="item-entry-button text-center">
    <div class="item-entry-button__sprite" :style="spriteStyle">
      <div v-if="amount > 0" class="item-entry-button__amount">{{ amount }}</div>
    </div>
    <span>
      {{ name }}
    </span>
  </div>

</template>

<script>
import {computed} from "@vue/reactivity";
import {backendUri} from "@/utils/settings";

export default {
  name: "ItemEntryButton",
  props: {
    id: Number,
    amount: Number,
    name: String,
    sprite_name: String,
    usable: Boolean
  },
  setup(props) {


    const spriteStyle = computed(() => {
      return {
        backgroundImage: `url(${backendUri}static/twitchextension/img/balls/${props.sprite_name}.svg)`
      };
    });

    return {
      spriteStyle,
    }
  }
}
</script>

<style lang="scss" scoped>
.item-entry-button {
  padding-top: 56px;
  padding-bottom: 20px;
  cursor: pointer;
  user-select: none;

  &__sprite {
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    background-size: 100%;
    background-position: center;
    background-repeat: no-repeat;
    height: 50px;
    width: 50px;
    transition: all 100ms ease;
  }

  &:hover &__sprite {
    height: 60px;
    width: 60px;
    top: -4px;
  }

  &__amount {
    position: absolute;
    color: #ffffff;
    background-color: rgba(23, 23, 23, 0.74);
    width: 19px;
    height: 19px;
    left: calc(50% + 12px);
    border-radius: 20px;
    font-size: small;
  }


}
</style>